import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";

interface EdMarkIconProps {
  /** Figma Tracker eyebrow / Ed chip default is 28px */
  size?: number;
  className?: string;
  "data-testid"?: string;
}

/**
 * Ed mascot mark used in Tracker surfaces (Figma node 42577:3596).
 * Use `ed`, not `edgen` — the latter is the wordmark/radar glyph.
 */
export const EdMarkIcon: React.FC<EdMarkIconProps> = ({
  size = 28,
  className,
  "data-testid": testId,
}) => {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center",
        className,
      )}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <Icon
        name="ed"
        size={size}
        className="text-content_brand_primary"
        data-testid={testId}
      />
    </span>
  );
};
